/**
 * @fileoverview POST handler for the "/apps/:app_group_id/user_imports/:import_id/cancel_validation" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsImportIdCancelValidationCacheKeys } from "./constants";
import type { PostAppsAppGroupIdUserImportsImportIdCancelValidationProps } from "./types";

export const postCancelUserImportValidation = reactQueryMutationAdapter(
  appsAppGroupIdUserImportsImportIdCancelValidationCacheKeys,
  ({ appGroupId, importId }: PostAppsAppGroupIdUserImportsImportIdCancelValidationProps): Promise<void> => {
    return fetch(`/apps/${appGroupId}/user_imports/${importId}/cancel_validation`, "POST", {});
  }
);
